/** Shared copy of the SASE pages (names per SASE plan §9). */
export const SASE_TITLE = "SASE";
export const SASE_NOT_AVAILABLE =
  "SASE is not switched on for this cloud. Your provider turns it on; nothing else changes.";
